<div class="progressbarClass">
  <ion-progress-bar #progressBarRef value="{{value}}" [style.height.px]="pxProgressBarHeight"></ion-progress-bar>
  <div class="progressbarText" [style.font-size.px]="pxFontSize">
    {{text}}
  </div>
</div>
